<template>
	<div class="order_box">
		<div class="calendar">
			<div class="title">My classes calendar</div>
			
			<div class="calendar_main">
				<div class="select_list flex">
					<div class="item flex align-center justify-between">
						<el-select v-model="course_age_id" clearable  placeholder="for any age" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in ageList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="timeStatus" clearable   placeholder="Any time" size="small"  @change="changeTime">
						   <el-option
						     v-for="item in timeOptions"
						     :key="item.value"
						     :label="item.label"
						     :value="item.value">
						   </el-option>
						</el-select>
						
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="course_shop_id" clearable  placeholder="Any Venue" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in shopList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="course_type_id" clearable  placeholder="Any class" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in classifyList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="selectWeek" clearable  placeholder="Any day" size="small"  @change="changeWeek">
						   <el-option
						     v-for="item in selectWeekList"
						     :key="item.id"
						     :label="item.label"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
				</div>
				<div class="calendar_header flex align-center justify-between">
					<div class="left flex align-center" @click="lastMonth">
						<img src="../../../assets/images/icon/left.png" alt="">
						<span>Last week</span>
					</div>
					<div class="date">{{showTime1}}-{{showTime2}}</div>
					<div class="right flex align-center" @click="nextMonth">
						<span>Next week</span>
						<img src="../../../assets/images/icon/right.png" alt="">
					</div>
				</div>
				<div class="weeklist">
					<ul class="weekName flex align-center justify-between">
						<li class="item" v-for="(item,index) in weekList" :key="index">
							<span>{{item}}</span>
							<span class="day">{{weekDayList[index]}}</span>
						</li>
					</ul>
					<div class="course_list flex  justify-between">
						<div class="day_item" v-for="(item,index) in courseList" :key="index">
							<div>
								<div class="item" v-for="(ite,ind) in item.course" :key="ind" >
									<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
									<div class="place line_two">{{ite.course_shop_name}}</div>
									<div class="info" :style="{'background':ite.color}">
										<div class="name">{{ite.course_type_name}} </div>
										<div class="age">{{ite.course_age_name}}</div>
									</div>
									<!-- <div class="tag" v-if="num == 0">waiting list</div> -->
									<!-- <div class="tag_list flex align-center" v-else-if="ite.is_try == 1">
										<div class="tag" @click="openIntro(ite.id)">试课</div>
										<div class="tag" @click="ensureOrder(ite.course_id)">立即订课</div>
									</div> -->
									<div class="tag" v-if="ite.isShow" @click="changeCourse(ite)">Reschedule</div>
								</div>
								<div class="add_course" @click="addCourse">
									<img src="../../../assets/images/icon/add.png" alt="">
									<div class="name">add a class</div>
								</div>
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
		<div class="calendar calendar_second">
			<div class="title">My events calendar</div>
			
			<div class="calendar_main">
				<div class="select_list flex">
					<div class="item flex align-center justify-between">
						<el-select v-model="events_age_id" clearable  placeholder="for any age" size="small"  @change="getEventsList">
						   <el-option
						     v-for="item in events_ageList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="events_timeStatus" clearable   placeholder="Any time" size="small"  @change="changeTime_events">
						   <el-option
						     v-for="item in events_timeOptions"
						     :key="item.value"
						     :label="item.label"
						     :value="item.value">
						   </el-option>
						</el-select>
						
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="events_shop_id" clearable  placeholder="Any Venue" size="small"  @change="getEventsList">
						   <el-option
						     v-for="item in events_shopList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="events_type_id" clearable  placeholder="Any class" size="small"  @change="getEventsList">
						   <el-option
						     v-for="item in events_classifyList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="events_selectWeek" clearable  placeholder="Any day" size="small"  @change="changeWeek_events">
						   <el-option
						     v-for="item in selectWeekList_events"
						     :key="item.id"
						     :label="item.label"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
				</div>
				<div class="calendar_header flex align-center justify-between">
					<div class="left flex align-center" @click="lastMonth_events">
						<img src="../../../assets/images/icon/left.png" alt="">
						<span>Last week</span>
					</div>
					<div class="date">{{events_showTime1}}-{{events_showTime2}}</div>
					<div class="right flex align-center" @click="nextMonth_events">
						<span>Next week</span>
						<img src="../../../assets/images/icon/right.png" alt="">
					</div>
				</div>
				<div class="weeklist">
					<ul class="weekName flex align-center justify-between">
						<li class="item" v-for="(item,index) in events_weekList" :key="index">
							<span>{{item}}</span>
							<span class="day">{{events_weekDayList[index]}}</span>
						</li>
					</ul>
					<div class="course_list flex  justify-between">
						<div class="day_item" v-for="(item,index) in eventsList" :key="index">
							<div>
								<div class="item event_item" v-for="(ite,ind) in item.course" :key="ind" >
									<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
									<div class="place line_two">{{ite.course_shop_name}}</div>
									<div class="info" :style="{'background':ite.color}">
										<div class="name">{{ite.course_type_name}} </div>
										<div class="age">{{ite.course_age_name}}</div>
									</div>
									<!-- <div class="tag" v-if="num == 0">waiting list</div> -->
									<!-- <div class="tag_list flex align-center" v-else-if="ite.is_try == 1">
										<div class="tag" @click="openIntro(ite.id)">试课</div>
										<div class="tag" @click="ensureOrder(ite.course_id)">立即订课</div>
									</div> -->
									<div class="tag" v-if="ite.isShow" @click="changeEvents(ite)">Reschedule</div>
								</div>
								<div class="add_course" @click="addEvents">
									<img src="../../../assets/images/icon/add.png" alt="">
									<div class="name">add a class</div>
								</div>
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
		<div class="calendar calendar_second">
			<div class="title">My parents calendar</div>
			
			<div class="calendar_main">
				<div class="select_list flex">
					<div class="item flex align-center justify-between">
						<el-select v-model="parents_age_id" clearable  placeholder="for any age" size="small"  @change="getParentsList">
						   <el-option
						     v-for="item in parents_ageList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="parents_timeStatus" clearable   placeholder="Any time" size="small"  @change="changeTime_parents">
						   <el-option
						     v-for="item in parents_timeOptions"
						     :key="item.value"
						     :label="item.label"
						     :value="item.value">
						   </el-option>
						</el-select>
						
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="parents_shop_id" clearable  placeholder="Any Venue" size="small"  @change="getParentsList">
						   <el-option
						     v-for="item in parents_shopList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="parents_type_id" clearable  placeholder="Any class" size="small"  @change="getParentsList">
						   <el-option
						     v-for="item in parents_classifyList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="parents_selectWeek" clearable  placeholder="Any day" size="small"  @change="changeWeek_parents">
						   <el-option
						     v-for="item in selectWeekList_parents"
						     :key="item.id"
						     :label="item.label"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
				</div>
				<div class="calendar_header flex align-center justify-between">
					<div class="left flex align-center" @click="lastMonth_parents">
						<img src="../../../assets/images/icon/left.png" alt="">
						<span>Last week</span>
					</div>
					<div class="date">{{parents_showTime1}}-{{parents_showTime2}}</div>
					<div class="right flex align-center" @click="nextMonth_parents">
						<span>Next week</span>
						<img src="../../../assets/images/icon/right.png" alt="">
					</div>
				</div>
				<div class="weeklist">
					<ul class="weekName flex align-center justify-between">
						<li class="item" v-for="(item,index) in parents_weekList" :key="index">
							<span>{{item}}</span>
							<span class="day">{{parents_weekDayList[index]}}</span>
						</li>
					</ul>
					<div class="course_list flex  justify-between">
						<div class="day_item" v-for="(item,index) in parentsList" :key="index">
							<div>
								<div class="item event_item" v-for="(ite,ind) in item.course" :key="ind" >
									<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
									<div class="place line_two">{{ite.course_shop_name}}</div>
									<div class="info" :style="{'background':ite.color}">
										<div class="name">{{ite.course_type_name}} </div>
										<div class="age">{{ite.course_age_name}}</div>
									</div>
									<!-- <div class="tag" v-if="num == 0">waiting list</div> -->
									<!-- <div class="tag_list flex align-center" v-else-if="ite.is_try == 1">
										<div class="tag" @click="openIntro(ite.id)">试课</div>
										<div class="tag" @click="ensureOrder(ite.course_id)">立即订课</div>
									</div> -->
									<div class="tag" v-if="ite.isShow" @click="changeParents(ite)">Reschedule</div>
								</div>
								<div class="add_course" @click="addParents">
									<img src="../../../assets/images/icon/add.png" alt="">
									<div class="name">add a class</div>
								</div>
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
		<div class="course_order">
			<div class="header">
				<div class="title">Classes Booking History</div>
				<!-- <div class="search">
					<input type="text" placeholder="请输入">
					<img src="../../../assets/images/icon/search.png" alt="">
				</div> -->
			</div>
			<div class="tabel_box">
				<el-table
				    :data="tableData"
				    stripe
				    style="width: 100%">
				    <el-table-column
				      prop="date"
				      label="">
					  <template slot-scope="scope">
						 <img :src="imgBaseUrl + scope.row.product.image" alt="">
						</template>
				    </el-table-column>
				    <el-table-column
				      prop="product.name"
				      label="Class">
				    </el-table-column>
				    <el-table-column
						width="140"
						 prop="createtime"
				      label="Order Time">
						<!-- <template slot-scope="scope">
						 <div>{{scope.row.product.start_date}}</div>
						</template> -->
				    </el-table-column>
					<!-- <el-table-column
					  prop="time"
					  width="150"
					  label="Time">
					  <template slot-scope="scope">
					   <div>{{scope.row.product.start_time}}-{{scope.row.product.end_time}}</div>
					  </template>
					</el-table-column> -->
					<!-- <el-table-column
					  prop="name"
					  label="操作人">
					</el-table-column> -->
					<el-table-column
					  prop=""
					  label="Child">
					  <template slot-scope="scope">
					   <span >{{scope.row.product.child.child_first_name}} {{scope.row.product.child.child_last_name}}</span>
					  </template>
					</el-table-column>
					<el-table-column
					  prop="order_status_txt"
					  width="200"
					  label="Payment Status">
					</el-table-column>
					<el-table-column
					  prop="pay_type"
					  label="Method">
					</el-table-column>
					<el-table-column
					  prop="total_price"
					  label="Amount">
					  <template slot-scope="scope">
						<div >£{{scope.row.total_price}}</div>
						</template>
					</el-table-column>
					<el-table-column
					  prop="combo_num"
					  label="Credits used">
					</el-table-column>
					<el-table-column
					  prop="date"
					  label="">
					  <template slot-scope="scope">
						 <div class="detail" @click="toCourseDetail(scope.row)">Details</div>
						</template>
					</el-table-column>
				  </el-table>
			</div>
			<div class="pages">
				<el-pagination
				      @size-change="handleSizeChange"
				      @current-change="handleCurrentChange_events"
				      :current-page="events_currentPage"
				      :page-sizes="[100, 200, 300, 400]"
				      :page-size="events_pageSize"
				      layout="prev, pager, next,sizes, jumper"
					  :total="events_total"
				      >
				    </el-pagination>
			</div>
			<!-- <div class="bottom_logo">
				<img src="../../../assets/images/icon/shou.png" alt="">
			</div> -->
		</div>
		<div class="course_order">
			<div class="header">
				<div class="title">Events Booking History</div>
				
			</div>
			<div class="tabel_box">
				<el-table
				    :data="events_tableData"
				    stripe
				    style="width: 100%">
				    <el-table-column
				      prop="date"
				      label="">
					  <template slot-scope="scope">
						 <img :src="imgBaseUrl + scope.row.product.image" alt="">
						</template>
				    </el-table-column>
				    <el-table-column
				      prop="product.name"
				      label="Class">
				    </el-table-column>
				    <el-table-column
						width="140"
						 prop="createtime"
				      label="Order Time">
						
				    </el-table-column>
					
					<el-table-column
					  prop=""
					  label="Child">
					  <template slot-scope="scope">
					   <span >{{scope.row.product.child.child_first_name}} {{scope.row.product.child.child_last_name}}</span>
					  </template>
					</el-table-column>
					<el-table-column
					  prop="order_status_txt"
					  width="200"
					  label="Payment Status">
					</el-table-column>
					<el-table-column
					  prop="pay_type"
					  label="Method">
					</el-table-column>
					<el-table-column
					  prop="total_price"
					  label="Amount">
					  <template slot-scope="scope">
						<div >£{{scope.row.total_price}}</div>
						</template>
					</el-table-column>
					<el-table-column
					  prop="combo_num"
					  label="Credits used">
					</el-table-column>
					<el-table-column
					  prop="date"
					  label="">
					  <template slot-scope="scope">
						 <div class="detail" @click="toEventsDetail(scope.row)">Details</div>
						</template>
					</el-table-column>
				  </el-table>
			</div>
			<div class="pages">
				<el-pagination
				      @size-change="handleSizeChange"
				      @current-change="handleCurrentChange"
				      :current-page="currentPage"
				      :page-sizes="[100, 200, 300, 400]"
				      :page-size="pageSize"
				      layout="prev, pager, next,sizes, jumper"
					  :total="total"
				      >
				    </el-pagination>
			</div>
			
		</div>
		<div class="course_order">
			<div class="header">
				<div class="title">Parents Booking History</div>
				
			</div>
			<div class="tabel_box">
				<el-table
				    :data="parents_tableData"
				    stripe
				    style="width: 100%">
				    <el-table-column
				      prop="date"
				      label="">
					  <template slot-scope="scope">
						 <img :src="imgBaseUrl + scope.row.product.image" alt="">
						</template>
				    </el-table-column>
				    <el-table-column
				      prop="product.name"
				      label="Class">
				    </el-table-column>
				    <el-table-column
						width="140"
						 prop="createtime"
				      label="Order Time">
						
				    </el-table-column>
					
				<!-- 	<el-table-column
					  prop=""
					  label="Name">
					  <template slot-scope="scope">
					   <span >{{scope.row.product.child.child_first_name}} {{scope.row.product.child.child_last_name}}</span>
					  </template>
					</el-table-column> -->
					<el-table-column
					  prop="order_status_txt"
					  width="200"
					  label="Payment Status">
					</el-table-column>
					<el-table-column
					  prop="pay_type"
					  label="Method">
					</el-table-column>
					<el-table-column
					  prop="total_price"
					  label="Amount">
					  <template slot-scope="scope">
						<div >£{{scope.row.total_price}}</div>
						</template>
					</el-table-column>
					<el-table-column
					  prop="combo_num"
					  label="Credits used">
					</el-table-column>
					<el-table-column
					  prop="date"
					  label="">
					  <template slot-scope="scope">
						 <div class="detail" @click="toParentsDetail(scope.row)">Details</div>
						</template>
					</el-table-column>
				  </el-table>
			</div>
			<div class="pages">
				<el-pagination
				      @size-change="handleSizeChange"
				      @current-change="handleCurrentChange"
				      :current-page="currentPage"
				      :page-sizes="[100, 200, 300, 400]"
				      :page-size="pageSize"
				      layout="prev, pager, next,sizes, jumper"
					  :total="total"
				      >
				    </el-pagination>
			</div>
			
		</div>
		<div class="course_order">
			<div class="header">
				<div class="title">Products Order History</div>
				<!-- <div class="search">
					<input type="text" placeholder="请输入">
					<img src="../../../assets/images/icon/search.png" alt="">
				</div> -->
			</div>
			<div class="tabel_box">
				<el-table
				    :data="productData"
				    stripe
				    style="width: 100%">
					<el-table-column
					  prop="order_sn"
					  width="200"
					  label="Order Number">
					</el-table-column>
				    <el-table-column
				      label="Product picture">
					  <template slot-scope="scope">
						 <img :src="imgBaseUrl+scope.row.goods[0].image" alt="">
						</template>
				    </el-table-column>
				    <el-table-column
				      prop="goods[0].name"
				      label="Product name">
				    </el-table-column>
				    <el-table-column
				      prop="order_status_txt"
					  width="200"
				      label="Order status">
				    </el-table-column>
					<el-table-column
					  prop="total_price"
					  width="150"
					  label="Amount">
					</el-table-column>
					<el-table-column
					  prop="createtime"
					  label="Order time">
					</el-table-column>
					
					</el-table-column>
					<el-table-column
					  prop="date"
					  label="">
					  <template slot-scope="scope">
						 <div class="detail" @click="toProduct(scope.row)">Detail</div>
						</template>
					</el-table-column>
				  </el-table>
			</div>
			<div class="pages">
				<el-pagination
				      @size-change="handleSizeChange2"
				      @current-change="handleCurrentChange2"
				      :current-page="secondCurrentPage"
				      :page-sizes="[100, 200, 300, 400]"
				      :page-size="secondPageSize"
				      layout="prev, pager, next,sizes, jumper"
					  :total="secondTotal"
				      >
				    </el-pagination>
			</div>
			<!-- <div class="bottom_logo">
				<img src="../../../assets/images/icon/shou.png" alt="">
			</div> -->
		</div>
		<div class="model" v-if="isChange" @click="isChange = false">
			<div class="model_calendar" @click.stop="">
				<div class="title">Booked class:{{changeCourseName}} (Please select the class in this calander you'd like to rescheule to)</div>
				<div class="calendar_main">
					<div class="select_list flex align-center">
						<div class="name">*Reschedule to:</div>
						<div class="search">
							<input type="text" placeholder=" Search">
							<img src="../../../assets/images/icon/search.png" alt="">
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="second_course_age_id" clearable  placeholder="for any age" size="small"  @change="second_getCourseList">
							   <el-option
							     v-for="item in ageList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="second_timeStatus" clearable   placeholder="Any time" size="small"  @change="second_changeTime">
							   <el-option
							     v-for="item in timeOptions"
							     :key="item.value"
							     :label="item.label"
							     :value="item.value">
							   </el-option>
							</el-select>
							
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="second_course_shop_id" clearable  placeholder="Any Venue" size="small"  @change="second_getCourseList">
							   <el-option
							     v-for="item in shopList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center ustify-between">
							<el-select v-model="second_course_type_id" clearable  placeholder="Any class" size="small"  @change="second_getCourseList">
							   <el-option
							     v-for="item in classifyList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center ustify-between">
							<el-select v-model="second_selectWeek" clearable  placeholder="Any class" size="small"  @change="second_changeWeek">
							   <el-option
							     v-for="item in selectWeekList"
							     :key="item.id"
							     :label="item.label"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						
					</div>
					<div class="calendar_header flex align-center justify-between">
						<div class="left flex align-center" @click="second_lastMonth">
							<img src="../../../assets/images/icon/left.png" alt="">
							<span>Last week</span>
						</div>
						<div class="date">{{second_showTime1}}-{{second_showTime2}}</div>
						<div class="right flex align-center" @click="second_nextMonth">
							<span>Next week</span>
							<img src="../../../assets/images/icon/right.png" alt="">
						</div>
					</div>
					<div class="weeklist">
						<ul class="weekName flex align-center justify-between">
							<li class="item" v-for="(item,index) in weekList" :key="index">
								<span>{{item}}</span>
								<span class="day">{{second_weekDayList[index]}}</span>
							</li>
						</ul>
						<div class="course_list flex  justify-between">
							<div class="day_item" v-for="(item,index) in second_courseList" :key="index">
								<div>
									<div class="item" v-for="(ite,ind) in item.course" :key="ind" >
										<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
										<div class="place line_two">{{ite.course_shop_name}}</div>
										<div class="info" :style="{'background':ite.color}">
											<div class="name">{{ite.course_type_name}} </div>
											<div class="age">{{ite.course_age_name}}</div>
										</div>
										<div class="tag" v-if="ite.is_expired" @click="toChangeCourse(ite)">Select</div>
										
									</div>
									
								</div>
							</div>
						</div>
						
					</div>
					<!-- <div class="send flex align-center justify-center">
						<img v-if="selectSend" src="../../../assets/images/icon/select_active.png" alt="">
						<img v-else src="../../../assets/images/icon/select.png" alt="">
						<div>发送邮件通知</div>
					</div> -->
					<!-- <div class="submit_btn" >确认</div> -->
				</div>
				
				
			</div>
		</div>
		<div class="model" v-if="events_isChange" @click="events_isChange = false">
			<div class="model_calendar" @click.stop="">
				<div class="title">Booked class:{{events_changeCourseName}} (Please select the class in this calander you'd like to rescheule to)</div>
				<div class="calendar_main">
					<div class="select_list flex align-center">
						<div class="name">*Reschedule to:</div>
						<div class="search">
							<input type="text" placeholder=" Search">
							<img src="../../../assets/images/icon/search.png" alt="">
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="second_events_age_id" clearable  placeholder="for any age" size="small"  @change="second_getEventsList">
							   <el-option
							     v-for="item in events_ageList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="events_second_timeStatus" clearable   placeholder="Any time" size="small"  @change="second_changeTime_events">
							   <el-option
							     v-for="item in events_timeOptions"
							     :key="item.value"
							     :label="item.label"
							     :value="item.value">
							   </el-option>
							</el-select>
							
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="second_events_shop_id" clearable  placeholder="Any Venue" size="small"  @change="second_getEventsList">
							   <el-option
							     v-for="item in events_shopList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center ustify-between">
							<el-select v-model="second_events_type_id" clearable  placeholder="Any class" size="small"  @change="second_getEventsList">
							   <el-option
							     v-for="item in events_classifyList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center ustify-between">
							<el-select v-model="events_second_selectWeek" clearable  placeholder="Any class" size="small"  @change="second_changeWeek_events">
							   <el-option
							     v-for="item in events_selectWeekList"
							     :key="item.id"
							     :label="item.label"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						
					</div>
					<div class="calendar_header flex align-center justify-between">
						<div class="left flex align-center" @click="second_lastMonth_events">
							<img src="../../../assets/images/icon/left.png" alt="">
							<span>Last week</span>
						</div>
						<div class="date">{{events_second_showTime1}}-{{events_second_showTime2}}</div>
						<div class="right flex align-center" @click="second_nextMonth_events">
							<span>Next week</span>
							<img src="../../../assets/images/icon/right.png" alt="">
						</div>
					</div>
					<div class="weeklist">
						<ul class="weekName flex align-center justify-between">
							<li class="item" v-for="(item,index) in events_weekList" :key="index">
								<span>{{item}}</span>
								<span class="day">{{events_second_weekDayList[index]}}</span>
							</li>
						</ul>
						<div class="course_list flex  justify-between">
							<div class="day_item" v-for="(item,index) in second_eventsList" :key="index">
								<div>
									<div class="item event_item" v-for="(ite,ind) in item.course" :key="ind" >
										<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
										<div class="place line_two">{{ite.course_shop_name}}</div>
										<div class="info" :style="{'background':ite.color}">
											<div class="name">{{ite.course_type_name}} </div>
											<div class="age">{{ite.course_age_name}}</div>
										</div>
										<div class="tag" v-if="ite.is_expired" @click="toChangeEvents(ite)">Select</div>
										
									</div>
									
								</div>
							</div>
						</div>
						
					</div>
					
				</div>
				
				
			</div>
		</div>
		<div class="model" v-if="parents_isChange" @click="parents_isChange = false">
			<div class="model_calendar" @click.stop="">
				<div class="title">Booked class:{{parents_changeCourseName}} (Please select the class in this calander you'd like to rescheule to)</div>
				<div class="calendar_main">
					<div class="select_list flex align-center">
						<div class="name">*Reschedule to:</div>
						<div class="search">
							<input type="text" placeholder=" Search">
							<img src="../../../assets/images/icon/search.png" alt="">
						</div>
						<div class="item flex align-centerparents justify-between">
							<el-select v-model="second_parents_age_id" clearable  placeholder="for any age" size="small"  @change="second_getParentsList">
							   <el-option
							     v-for="item in parents_ageList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="parents_second_timeStatus" clearable   placeholder="Any time" size="small"  @change="second_changeTime_parents">
							   <el-option
							     v-for="item in parents_timeOptions"
							     :key="item.value"
							     :label="item.label"
							     :value="item.value">
							   </el-option>
							</el-select>
							
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="second_parents_shop_id" clearable  placeholder="Any Venue" size="small"  @change="second_getParentsList">
							   <el-option
							     v-for="item in parents_shopList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center ustify-between">
							<el-select v-model="second_parents_type_id" clearable  placeholder="Any class" size="small"  @change="second_getParentsList">
							   <el-option
							     v-for="item in parents_classifyList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center ustify-between">
							<el-select v-model="parents_second_selectWeek" clearable  placeholder="Any class" size="small"  @change="second_changeWeek_parents">
							   <el-option
							     v-for="item in parents_selectWeekList"
							     :key="item.id"
							     :label="item.label"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						
					</div>
					<div class="calendar_header flex align-center justify-between">
						<div class="left flex align-center" @click="second_lastMonth_parents">
							<img src="../../../assets/images/icon/left.png" alt="">
							<span>Last week</span>
						</div>
						<div class="date">{{parents_second_showTime1}}-{{parents_second_showTime2}}</div>
						<div class="right flex align-center" @click="second_nextMonth_parents">
							<span>Next week</span>
							<img src="../../../assets/images/icon/right.png" alt="">
						</div>
					</div>
					<div class="weeklist">
						<ul class="weekName flex align-center justify-between">
							<li class="item" v-for="(item,index) in parents_weekList" :key="index">
								<span>{{item}}</span>
								<span class="day">{{parents_second_weekDayList[index]}}</span>
							</li>
						</ul>
						<div class="course_list flex  justify-between">
							<div class="day_item" v-for="(item,index) in second_parentsList" :key="index">
								<div>
									<div class="item event_item" v-for="(ite,ind) in item.course" :key="ind" >
										<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
										<div class="place line_two">{{ite.course_shop_name}}</div>
										<div class="info" :style="{'background':ite.color}">
											<div class="name">{{ite.course_type_name}} </div>
											<div class="age">{{ite.course_age_name}}</div>
										</div>
										<div class="tag" v-if="ite.is_expired" @click="toChangeParents(ite)">Select</div>
										
									</div>
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import parentCalendar from '/src/components/orderList/parentsCalendar.vue'
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				weekList:['Mon','Tue','Wed','Thur','Fri','Sat','Sun'],
				total:10,
				secondTotal:10,
				currentPage:1,
				secondCurrentPage:1,
				pageSize:0,
				secondPageSize:0,
				productData:[],
				tableData: [],
				// 日历
				classifyList:[],
				shopList:[],
				ageList:[],
				course_age_id:'',
				course_shop_id:'',
				course_type_id:'',
				start_time:'',
				start_time1:'',
				end_time1:'',
				end_time:'',
				showTime1:'',
				showTime2:'',
				end_date:'',
				start_date:'',       
				weekStartDay:'',     //一周开始事件
				weekDayList:[],     //每周日期列表
				courseList:[],     //日历课程列表
				timeStatus:'',
				timeOptions:[{
					value:0,
					label:'AM'
				},{
					value:1,
					label:'PM'
				}],
				selectWeekList:[{id:0,label:'Monday'},{id:1,label:'Tuesday'},{id:2,label:'Wednesday'},{id:3,label:'Thursday'},{id:4,label:'Friday'},{id:5,label:'Saturday'},{id:6,label:'Sunday'}],
				selectWeek:'',
				select_date:'',
				// 改课日历
				second_course_age_id:'',
				second_course_shop_id:'',
				second_course_type_id:'',
				second_start_time:'',
				second_start_time1:'',
				second_end_time1:'',
				second_end_time:'',
				second_showTime1:'',
				second_showTime2:'',
				second_end_date:'',
				second_start_date:'',       
				weekStartDay:'',     //一周开始事件
				second_weekDayList:[],     //每周日期列表
				second_courseList:[],     //日历课程列表
				second_timeStatus:'',
				second_selectWeek:'',
				second_select_date:'',
				changeCourseName:'',
				isChange:false,
				selectSend:false,
				changeCourseId:'',
				cpuId:'',
				select_date_index:-1,
				second_select_date_index:-1,
				// events
				events_weekList:['Mon','Tue','Wed','Thur','Fri','Sat','Sun'],
				events_total:10,
				events_currentPage:1,
				events_pageSize:0,
				events_tableData: [],
				// 日历
				events_classifyList:[],
				events_shopList:[],
				events_ageList:[],
				events_age_id:'',
				events_shop_id:'',
				events_type_id:'',
				events_start_time:'',
				events_start_time1:'',
				events_end_time1:'',
				events_end_time:'',
				events_showTime1:'',
				events_showTime2:'',
				events_end_date:'',
				events_start_date:'',       
				events_weekStartDay:'',     //一周开始事件
				events_weekDayList:[],     //每周日期列表
				eventsList:[],     //日历课程列表
				events_timeStatus:'',
				events_timeOptions:[{
					value:0,
					label:'AM'
				},{
					value:1,
					label:'PM'
				}],
				events_selectWeekList:[{id:0,label:'Monday'},{id:1,label:'Tuesday'},{id:2,label:'Wednesday'},{id:3,label:'Thursday'},{id:4,label:'Friday'},{id:5,label:'Saturday'},{id:6,label:'Sunday'}],
				events_selectWeek:'',
				events_select_date:'',
				// 改课日历
				second_events_age_id:'',
				second_events_shop_id:'',
				second_events_type_id:'',
				events_second_start_time:'',
				events_second_start_time1:'',
				events_second_end_time1:'',
				events_second_end_time:'',
				events_second_showTime1:'',
				events_second_showTime2:'',
				events_second_end_date:'',
				events_second_start_date:'',       
				events_weekStartDay:'',     //一周开始事件
				events_second_weekDayList:[],     //每周日期列表
				second_eventsList:[],     //日历课程列表
				events_second_timeStatus:'',
				events_second_selectWeek:'',
				events_second_select_date:'',
				events_changeCourseName:'',
				events_isChange:false,
				events_selectSend:false,
				events_changeCourseId:'',
				events_cpuId:'',
				events_select_date_index:-1,
				events_second_select_date_index:-1,
				// parents
				parents_weekList:['Mon','Tue','Wed','Thur','Fri','Sat','Sun'],
				parents_total:10,
				parents_currentPage:1,
				parents_pageSize:0,
				parents_tableData: [],
				// 日历
				parents_classifyList:[],
				parents_shopList:[],
				parents_ageList:[],
				parents_age_id:'',
				parents_shop_id:'',
				parents_type_id:'',
				parents_start_time:'',
				parents_start_time1:'',
				parents_end_time1:'',
				parents_end_time:'',
				parents_showTime1:'',
				parents_showTime2:'',
				parents_end_date:'',
				parents_start_date:'',       
				parents_weekStartDay:'',     //一周开始事件
				parents_weekDayList:[],     //每周日期列表
				parentsList:[],     //日历课程列表
				parents_timeStatus:'',
				parents_timeOptions:[{
					value:0,
					label:'AM'
				},{
					value:1,
					label:'PM'
				}],
				parents_selectWeekList:[{id:0,label:'Monday'},{id:1,label:'Tuesday'},{id:2,label:'Wednesday'},{id:3,label:'Thursday'},{id:4,label:'Friday'},{id:5,label:'Saturday'},{id:6,label:'Sunday'}],
				parents_selectWeek:'',
				parents_select_date:'',
				// 改课日历
				second_parents_age_id:'',
				second_parents_shop_id:'',
				second_parents_type_id:'',
				parents_second_start_time:'',
				parents_second_start_time1:'',
				parents_second_end_time1:'',
				parents_second_end_time:'',
				parents_second_showTime1:'',
				parents_second_showTime2:'',
				parents_second_end_date:'',
				parents_second_start_date:'',       
				parents_weekStartDay:'',     //一周开始事件
				parents_second_weekDayList:[],     //每周日期列表
				second_parentsList:[],     //日历课程列表
				parents_second_timeStatus:'',
				parents_second_selectWeek:'',
				parents_second_select_date:'',
				parents_changeCourseName:'',
				parents_isChange:false,
				parents_selectSend:false,
				parents_changeCourseId:'',
				parents_cpuId:'',
				parents_select_date_index:-1,
				parents_second_select_date_index:-1,
			}
		},
		created(){
			this.getClassify();
			this.getShopList();
			this.getAgeList();
			this.getWeek(new Date());
			
			this.getProductOrder();
			this.getCourseOrder();
			// events
			this.getClassify_events();
			this.getShopList_events();
			this.getAgeList_events();
			this.getWeek_events(new Date());
			
			this.getCourseOrder_events();
			// parents
			this.getClassify_parents();
			this.getShopList_parents();
			this.getAgeList_parents();
			this.getWeek_parents(new Date());
			
			this.getCourseOrder_parents();
		},
		methods:{
			toProduct(item){
				this.$router.push({path:'/home/userInfo/orderDetail',query:{order_sn:item.order_sn}})
			},
			toCourseDetail(item){
				this.$router.push({path:'/home/userInfo/orderStatus',query:{order_sn:item.order_sn}})
		
			},
			addCourse(){
				this.$router.push({path:'/home/classes',query:{date:this.start_date}})
			},
			changeCourse(item){
				this.isChange = true;
				this.changeCourseName = item.course_type_name;
				this.changeCourseId = item.id;
				this.cpuId = item.cpu_id;
				this.second_getWeek(new Date());
			},
			toChangeCourse(item){
				var params = {
					cpu_id:this.cpuId,
					change_id:item.id,
				}
				this.$api.post('course_order/change',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Succesfully rescheduled'
						})
						this.isChange = false;
						this.getCourseList()
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			getCourseOrder(){
				this.$api.post('course_order/getOrderList',{page:this.currentPage},res=>{
					if(res.code == 1){
						res.data.data.forEach((item,index)=>{
							item.product.start_time = item.product.start_time.substring(0,5)
							item.product.end_time = item.product.end_time.substring(0,5);
							item.order_status_txt = item.order_status == 0 ? 'payment outstanding' : item.order_status == 1 ? 'paid' :item.order_status == -1 ? 'cancelled' : ''
						})
						this.tableData = res.data.data;
						this.total = res.data.total;
						this.pageSize = res.data.per_page;
					}
				})
			},
			getProductOrder(){
				this.$api.post('order/getOrderList',{page:this.secondCurrentPage},res=>{
					if(res.code == 1){
						res.data.data.forEach((item,index)=>{
							item.order_status_txt = item.order_status == 0 ? 'payment outstanding' : item.order_status == 1 ? 'paid' :item.order_status == -1 ? 'cancelled' : ''
						})
						this.productData = res.data.data;
						this.secondTotal = res.data.total;
						this.secondPageSize = res.data.per_page
					}
				})
			},
			handleCurrentChange(val){
				this.currentPage = val;
				this.getCourseOrder()
			},
			handleCurrentChange2(val){
				this.secondCurrentPage = val;
				this.getProductOrder()
			},
			handleSizeChange(e){
				console.log(e)
			},
			changeTime(e){
				console.log(e)
				if(this.timeStatus == 0){
					this.start_time = '00:00';
					this.end_time = '12:00'
				}else{
					this.start_time = '12:00';
					this.end_time = '24:00'
				}
				this.getCourseList()
			},
			changeWeek(e){
				var start = this.start_date.substring(this.start_date.length-2);
				this.select_date_index = e;
				if(this.weekDayList[e] > start){
					this.select_date = this.start_date.substring(0,this.start_date.length-2)+this.weekDayList[e]
				}else{
					this.select_date = this.end_date.substring(0,this.end_date.length-2)+this.weekDayList[e]
				}
				this.getCourseList()
			},
			
			getWeek(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.weekDayList = weekList;
				this.showTime1 = day1+'/'+month1+'/'+year1;
				this.showTime2 = day2+'/'+month2+'/'+year2;
				this.start_date = year1+'-'+month1+'-'+day1;
				this.end_date = year2+'-'+month2+'-'+day2;
				var start = this.start_date.substring(this.start_date.length-2);
				if(this.select_date_index>=0){
					if(this.weekDayList[this.select_date_index] > start){
						this.select_date = this.start_date.substring(0,this.start_date.length-2)+this.weekDayList[this.select_date_index]
					}else{
						this.select_date = this.end_date.substring(0,this.end_date.length-2)+this.weekDayList[this.select_date_index]
					}
				}
				this.getCourseList()
			},
			lastMonth(){
				var date = new Date(this.start_date).getTime();
				date = date - 24* 60*60*1000;
				this.getWeek(new Date(date))
			},
			nextMonth(){
				var date = new Date(this.end_date).getTime();
				date = date + 24* 60*60*1000;
				this.getWeek(new Date(date))
			},
			getCourseList(){
				var params = {
					start_date:this.start_date,
					end_date:this.end_date,
					start_time:this.start_time,
					end_time:this.end_time,
					course_age_id:this.course_age_id,
					course_type_id:this.course_type_id,
					course_shop_id:this.course_shop_id,
					date:this.select_date
				}
				this.$api.post('Course/getMyCourseList',params,res=>{
					if(res.code == 1){
						var nowDate = new Date().getTime();
						res.data.forEach((item,index)=>{
							var itemDate = item.date;
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									var courseDate = itemDate+' '+ite.start_time;
									courseDate = new Date(courseDate).getTime();
									if(nowDate > courseDate){
										ite.isShow = false
									}else{
										ite.isShow = true
									}
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.courseList = res.data;
					}
				})
			},
			second_changeTime(e){
				console.log(e)
				if(this.second_timeStatus == 0){
					this.second_start_time = '00:00';
					this.second_end_time = '12:00'
				}else{
					this.second_start_time = '12:00';
					this.second_end_time = '24:00'
				}
				this.second_getCourseList()
			},
			second_changeWeek(e){
				var start = this.second_start_date.substring(this.second_start_date.length-2);
				this.second_select_date_index =e;
				if(this.second_weekDayList[e] > start){
					this.second_select_date = this.second_start_date.substring(0,this.second_start_date.length-2)+this.second_weekDayList[e]
				}else{
					this.second_select_date = this.second_end_date.substring(0,this.second_end_date.length-2)+this.second_weekDayList[e]
				}
				this.second_getCourseList()
			},
			
			second_getWeek(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.second_weekDayList = weekList;
				this.second_showTime1 = day1+'/'+month1+'/'+year1;
				this.second_showTime2 = day2+'/'+month2+'/'+year2;
				this.second_start_date = year1+'-'+month1+'-'+day1;
				this.second_end_date = year2+'-'+month2+'-'+day2;
				var start = this.second_start_date.substring(this.second_start_date.length-2);
				if(this.second_weekDayList[this.second_select_date_index] > start){
					this.second_select_date = this.second_start_date.substring(0,this.second_start_date.length-2)+this.second_weekDayList[this.second_select_date_index]
				}else{
					this.second_select_date = this.second_end_date.substring(0,this.second_end_date.length-2)+this.second_weekDayList[this.second_select_date_index]
				}
				this.second_getCourseList()
			},
			second_lastMonth(){
				var date = new Date(this.second_start_date).getTime();
				date = date - 24* 60*60*1000;
				this.second_getWeek(new Date(date))
			},
			second_nextMonth(){
				var date = new Date(this.second_end_date).getTime();
				date = date + 24* 60*60*1000;
				this.second_getWeek(new Date(date))
			},
			second_getCourseList(){
				var params = {
					start_date:this.second_start_date,
					end_date:this.second_end_date,
					start_time:this.second_start_time,
					end_time:this.second_end_time,
					course_age_id:this.second_course_age_id,
					course_type_id:this.second_course_type_id,
					course_shop_id:this.second_course_shop_id,
					course_products_id:this.changeCourseId,
					date:this.second_select_date
				}
				this.$api.post('Course/getChangeList',params,res=>{
					if(res.code == 1){
						res.data.forEach((item,index)=>{
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.second_courseList = res.data;
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
						this.isChange= false;
						// this.second_courseList = []
					}
				})
			},
			getClassify(){
				this.$api.post('Course/getCourseType',{},res=>{
					if(res.code == 1){
						this.classifyList = res.data;
					}
				})
			},
			getShopList(){
				this.$api.post('Course/getCourseShop',{},res=>{
					if(res.code == 1){
						this.shopList = res.data;
					}
				})
			},
			getAgeList(){
				this.$api.post('Course/getCourseAge',{},res=>{
					if(res.code == 1){
						this.ageList = res.data;
					}
				})
			},
			// events
			toEventsDetail(item){
				this.$router.push({path:'/home/userInfo/eventOrderDetail',query:{order_sn:item.order_sn}})
			},
			addEvents(){
				this.$router.push({path:'/home/event',query:{date:this.start_date}})
			},
			changeEvents(item){
				this.events_isChange = true;
				this.events_changeCourseName = item.course_type_name;
				this.events_changeCourseId = item.id;
				this.events_cpuId = item.cpu_id;
				this.second_getWeek_events(new Date());
			},
			toChangeEvents(item){
				var params = {
					cpu_id:this.events_cpuId,
					change_id:item.id,
				}
				this.$api.post('Events_order/change',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Succesfully rescheduled'
						})
						this.events_isChange = false;
						this.getEventsList()
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			getCourseOrder_parents(){
				this.$api.post('Events_order/getOrderList',{page:this.events_currentPage},res=>{
					if(res.code == 1){
						res.data.data.forEach((item,index)=>{
							item.product.start_time = item.product.start_time.substring(0,5)
							item.product.end_time = item.product.end_time.substring(0,5);
							item.order_status_txt = item.order_status == 0 ? 'payment outstanding' : item.order_status == 1 ? 'paid' :item.order_status == -1 ? 'cancelled' : ''
						})
						this.events_tableData = res.data.data;
						this.events_total = res.data.total;
						this.events_pageSize = res.data.per_page;
					}
				})
			},
			
			handleCurrentChange_events(val){
				this.events_currentPage = val;
				this.getCourseOrder_parents()
			},
			
			handleSizeChange(e){
				console.log(e)
			},
			changeTime_events(e){
				console.log(e)
				if(this.events_timeStatus == 0){
					this.events_start_time = '00:00';
					this.events_end_time = '12:00'
				}else{
					this.events_start_time = '12:00';
					this.events_end_time = '24:00'
				}
				this.getEventsList()
			},
			changeWeek_events(e){
				var start = this.events_start_date.substring(this.events_start_date.length-2);
				this.events_select_date_index = e;
				if(this.events_weekDayList[e] > start){
					this.events_select_date = this.events_start_date.substring(0,this.events_start_date.length-2)+this.events_weekDayList[e]
				}else{
					this.events_select_date = this.events_end_date.substring(0,this.events_end_date.length-2)+this.events_weekDayList[e]
				}
				this.getEventsList()
			},
			
			getWeek_events(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.events_weekDayList = weekList;
				this.events_showTime1 = day1+'/'+month1+'/'+year1;
				this.events_showTime2 = day2+'/'+month2+'/'+year2;
				this.events_start_date = year1+'-'+month1+'-'+day1;
				this.events_end_date = year2+'-'+month2+'-'+day2;
				var start = this.events_start_date.substring(this.events_start_date.length-2);
				if(this.events_select_date_index>=0){
					if(this.events_weekDayList[this.events_select_date_index] > start){
						this.events_select_date = this.events_start_date.substring(0,this.events_start_date.length-2)+this.events_weekDayList[this.events_select_date_index]
					}else{
						this.events_select_date = this.events_end_date.substring(0,this.events_end_date.length-2)+this.events_weekDayList[this.events_select_date_index]
					}
				}
				this.getEventsList()
			},
			lastMonth_events(){
				var date = new Date(this.events_start_date).getTime();
				date = date - 24* 60*60*1000;
				this.getWeek_events(new Date(date))
			},
			nextMonth_events(){
				var date = new Date(this.events_end_date).getTime();
				date = date + 24* 60*60*1000;
				this.getWeek_events(new Date(date))
			},
			getEventsList(){
				var params = {
					start_date:this.events_start_date,
					end_date:this.events_end_date,
					start_time:this.events_start_time,
					end_time:this.events_end_time,
					course_age_id:this.events_age_id,
					course_type_id:this.events_type_id,
					course_shop_id:this.events_shop_id,
					date:this.events_select_date
				}
				this.$api.post('Events/getMyCourseList',params,res=>{
					if(res.code == 1){
						var nowDate = new Date().getTime();
						res.data.forEach((item,index)=>{
							var itemDate = item.date;
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									var courseDate = itemDate+' '+ite.start_time;
									courseDate = new Date(courseDate).getTime();
									if(nowDate > courseDate){
										ite.isShow = false
									}else{
										ite.isShow = true
									}
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.eventsList = res.data;
					}
				})
			},
			second_changeTime_events(e){
				console.log(e)
				if(this.events_second_timeStatus == 0){
					this.events_second_start_time = '00:00';
					this.events_second_end_time = '12:00'
				}else{
					this.events_second_start_time = '12:00';
					this.events_second_end_time = '24:00'
				}
				this.second_getEventsList()
			},
			second_changeWeek_events(e){
				var start = this.events_second_start_date.substring(this.events_second_start_date.length-2);
				this.events_second_select_date_index =e;
				if(this.events_second_weekDayList[e] > start){
					this.events_second_select_date = this.events_second_start_date.substring(0,this.events_second_start_date.length-2)+this.events_second_weekDayList[e]
				}else{
					this.events_second_select_date = this.events_second_end_date.substring(0,this.events_second_end_date.length-2)+this.events_second_weekDayList[e]
				}
				this.second_getEventsList()
			},
			
			second_getWeek_events(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.events_second_weekDayList = weekList;
				this.events_second_showTime1 = day1+'/'+month1+'/'+year1;
				this.events_second_showTime2 = day2+'/'+month2+'/'+year2;
				this.events_second_start_date = year1+'-'+month1+'-'+day1;
				this.events_second_end_date = year2+'-'+month2+'-'+day2;
				var start = this.events_second_start_date.substring(this.events_second_start_date.length-2);
				if(this.events_second_weekDayList[this.events_second_select_date_index] > start){
					this.events_second_select_date = this.events_second_start_date.substring(0,this.events_second_start_date.length-2)+this.events_second_weekDayList[this.events_second_select_date_index]
				}else{
					this.events_second_select_date = this.events_second_end_date.substring(0,this.events_second_end_date.length-2)+this.events_second_weekDayList[this.events_second_select_date_index]
				}
				this.second_getEventsList()
			},
			second_lastMonth_events(){
				var date = new Date(this.events_second_start_date).getTime();
				date = date - 24* 60*60*1000;
				this.second_getWeek_events(new Date(date))
			},
			second_nextMonth_events(){
				var date = new Date(this.events_second_end_date).getTime();
				date = date + 24* 60*60*1000;
				this.second_getWeek_events(new Date(date))
			},
			second_getEventsList(){
				var params = {
					start_date:this.events_second_start_date,
					end_date:this.events_second_end_date,
					start_time:this.events_second_start_time,
					end_time:this.events_second_end_time,
					course_age_id:this.second_events_age_id,
					course_type_id:this.second_events_type_id,
					course_shop_id:this.second_events_shop_id,
					course_products_id:this.events_changeCourseId,
					date:this.events_second_select_date
				}
				this.$api.post('Events/getChangeList',params,res=>{
					if(res.code == 1){
						res.data.forEach((item,index)=>{
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.second_eventsList = res.data;
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
						this.events_isChange= false;
						// this.second_courseList = []
					}
				})
			},
			getClassify_events(){
				this.$api.post('Events/getCourseType',{},res=>{
					if(res.code == 1){
						this.events_classifyList = res.data;
					}
				})
			},
			getShopList_events(){
				this.$api.post('Events/getCourseShop',{},res=>{
					if(res.code == 1){
						this.events_shopList = res.data;
					}
				})
			},
			getAgeList_events(){
				this.$api.post('Events/getCourseAge',{},res=>{
					if(res.code == 1){
						this.events_ageList = res.data;
					}
				})
			},
			// parents
			toParentsDetail(item){
				this.$router.push({path:'/home/userInfo/parentsOrderDetail',query:{order_sn:item.order_sn}})
			},
			addParents(){
				this.$router.push({path:'/home/parent',query:{date:this.start_date}})
			},
			changeParents(item){
				this.parents_isChange = true;
				this.parents_changeCourseName = item.course_type_name;
				this.parents_changeCourseId = item.id;
				this.parents_cpuId = item.cpu_id;
				this.second_getWeek_parents(new Date());
			},
			toChangeParents(item){
				var params = {
					cpu_id:this.parents_cpuId,
					change_id:item.id,
				}
				this.$api.post('parents_order/change',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Succesfully rescheduled'
						})
						this.parents_isChange = false;
						this.getparentsList()
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			getCourseOrder_events(){
				this.$api.post('parents_order/getOrderList',{page:this.events_currentPage},res=>{
					if(res.code == 1){
						res.data.data.forEach((item,index)=>{
							item.product.start_time = item.product.start_time.substring(0,5)
							item.product.end_time = item.product.end_time.substring(0,5);
							item.order_status_txt = item.order_status == 0 ? 'payment outstanding' : item.order_status == 1 ? 'paid' :item.order_status == -1 ? 'cancelled' : ''
						})
						this.parents_tableData = res.data.data;
						this.parents_total = res.data.total;
						this.parents_pageSize = res.data.per_page;
					}
				})
			},
			
			handleCurrentChange_events(val){
				this.parents_currentPage = val;
				this.getCourseOrder_events()
			},
			
			handleSizeChange(e){
				console.log(e)
			},
			changeTime_parents(e){
				console.log(e)
				if(this.parents_timeStatus == 0){
					this.parents_start_time = '00:00';
					this.parents_end_time = '12:00'
				}else{
					this.parents_start_time = '12:00';
					this.parents_end_time = '24:00'
				}
				this.getParentsList()
			},
			changeWeek_parents(e){
				var start = this.parents_start_date.substring(this.parents_start_date.length-2);
				this.parents_select_date_index = e;
				if(this.parents_weekDayList[e] > start){
					this.parents_select_date = this.parents_start_date.substring(0,this.parents_start_date.length-2)+this.parents_weekDayList[e]
				}else{
					this.parents_select_date = this.parents_end_date.substring(0,this.parents_end_date.length-2)+this.parents_weekDayList[e]
				}
				this.getParentsList()
			},
			
			getWeek_parents(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.parents_weekDayList = weekList;
				this.parents_showTime1 = day1+'/'+month1+'/'+year1;
				this.parents_showTime2 = day2+'/'+month2+'/'+year2;
				this.parents_start_date = year1+'-'+month1+'-'+day1;
				this.parents_end_date = year2+'-'+month2+'-'+day2;
				var start = this.parents_start_date.substring(this.parents_start_date.length-2);
				if(this.parents_select_date_index>=0){
					if(this.parents_weekDayList[this.parents_select_date_index] > start){
						this.parents_select_date = this.parents_start_date.substring(0,this.parents_start_date.length-2)+this.parents_weekDayList[this.parents_select_date_index]
					}else{
						this.parents_select_date = this.parents_end_date.substring(0,this.parents_end_date.length-2)+this.parents_weekDayList[this.parents_select_date_index]
					}
				}
				this.getParentsList()
			},
			lastMonth_parents(){
				var date = new Date(this.parents_start_date).getTime();
				date = date - 24* 60*60*1000;
				this.getWeek_parents(new Date(date))
			},
			nextMonth_parents(){
				var date = new Date(this.parents_end_date).getTime();
				date = date + 24* 60*60*1000;
				this.getWeek_parents(new Date(date))
			},
			getParentsList(){
				var params = {
					start_date:this.parents_start_date,
					end_date:this.parents_end_date,
					start_time:this.parents_start_time,
					end_time:this.parents_end_time,
					course_age_id:this.parents_age_id,
					course_type_id:this.parents_type_id,
					course_shop_id:this.parents_shop_id,
					date:this.parents_select_date
				}
				this.$api.post('Parents/getMyCourseList',params,res=>{
					if(res.code == 1){
						var nowDate = new Date().getTime();
						res.data.forEach((item,index)=>{
							var itemDate = item.date;
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									var courseDate = itemDate+' '+ite.start_time;
									courseDate = new Date(courseDate).getTime();
									if(nowDate > courseDate){
										ite.isShow = false
									}else{
										ite.isShow = true
									}
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.parentsList = res.data;
					}
				})
			},
			second_changeTime_parents(e){
				console.log(e)
				if(this.parents_second_timeStatus == 0){
					this.parents_second_start_time = '00:00';
					this.parents_second_end_time = '12:00'
				}else{
					this.parents_second_start_time = '12:00';
					this.parents_second_end_time = '24:00'
				}
				this.second_getParentsList()
			},
			second_changeWeek_parents(e){
				var start = this.parents_second_start_date.substring(this.parents_second_start_date.length-2);
				this.parents_second_select_date_index =e;
				if(this.parents_second_weekDayList[e] > start){
					this.parents_second_select_date = this.parents_second_start_date.substring(0,this.parents_second_start_date.length-2)+this.parents_second_weekDayList[e]
				}else{
					this.parents_second_select_date = this.parents_second_end_date.substring(0,this.parents_second_end_date.length-2)+this.parents_second_weekDayList[e]
				}
				this.second_getParentsList()
			},
			
			second_getWeek_parents(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.parents_second_weekDayList = weekList;
				this.parents_second_showTime1 = day1+'/'+month1+'/'+year1;
				this.parents_second_showTime2 = day2+'/'+month2+'/'+year2;
				this.parents_second_start_date = year1+'-'+month1+'-'+day1;
				this.parents_second_end_date = year2+'-'+month2+'-'+day2;
				var start = this.parents_second_start_date.substring(this.parents_second_start_date.length-2);
				if(this.parents_second_weekDayList[this.parents_second_select_date_index] > start){
					this.parents_second_select_date = this.parents_second_start_date.substring(0,this.parents_second_start_date.length-2)+this.parents_second_weekDayList[this.parents_second_select_date_index]
				}else{
					this.parents_second_select_date = this.parents_second_end_date.substring(0,this.parents_second_end_date.length-2)+this.parents_second_weekDayList[this.parents_second_select_date_index]
				}
				this.second_getParentsList()
			},
			second_lastMonth_parents(){
				var date = new Date(this.parents_second_start_date).getTime();
				date = date - 24* 60*60*1000;
				this.second_getWeek_parents(new Date(date))
			},
			second_nextMonth_parents(){
				var date = new Date(this.parents_second_end_date).getTime();
				date = date + 24* 60*60*1000;
				this.second_getWeek_parents(new Date(date))
			},
			second_getParentsList(){
				var params = {
					start_date:this.parents_second_start_date,
					end_date:this.parents_second_end_date,
					start_time:this.parents_second_start_time,
					end_time:this.parents_second_end_time,
					course_age_id:this.second_parents_age_id,
					course_type_id:this.second_parents_type_id,
					course_shop_id:this.second_parents_shop_id,
					course_products_id:this.parents_changeCourseId,
					date:this.parents_second_select_date
				}
				this.$api.post('Parents/getChangeList',params,res=>{
					if(res.code == 1){
						res.data.forEach((item,index)=>{
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.second_parentsList = res.data;
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
						this.parents_isChange= false;
						// this.second_courseList = []
					}
				})
			},
			getClassify_parents(){
				this.$api.post('Parents/getCourseType',{},res=>{
					if(res.code == 1){
						this.parents_classifyList = res.data;
					}
				})
			},
			getShopList_parents(){
				this.$api.post('Parents/getCourseShop',{},res=>{
					if(res.code == 1){
						this.parents_shopList = res.data;
					}
				})
			},
			getAgeList_parents(){
				this.$api.post('Parents/getCourseAge',{},res=>{
					if(res.code == 1){
						this.parents_ageList = res.data;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.order_box{
		padding: 30px 20px;
	}
	.calendar{
		width: 1240px;
		background: #5C707A;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		padding: 20px;
		&.calendar_second{
			margin-top: 20px;
		}
		.title{
			padding-top: 40px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #FFFFFF;
		}
		.type_list{
			.item{
				width: 200px;
				height: 60px;
				border: 2px solid #FFFFFF;
				border-radius: 5px 0px 0px 5px;
				line-height: 60px;
				text-align: center;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #FFFFFF;
				&.active{
					background: #FFFFFF;
					color: #5C707A;
				}
			}
		}
		.calendar_main{
			width: 1200px;
			margin: 0 auto;
			padding-top: 40px;
			.select_list{
				.item{
					// padding: 0 20px;
					height: 60px;
					background: #FFFFFF;
					border-radius: 10px;
					margin-right: 40px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					img{
						width: 27px;
						height: 15px;
						margin-left: 10px;
					}
				}
			}
			::v-deep .el-select-dropdown__list{
				padding: 15px 0;
			}
			::v-deep .el-select{
				// width: 100%;
				height: 100%;
			}
			::v-deep .el-input.el-input--suffix{
				height: 100%;
			}
			::v-deep .el-input__icon{
				line-height: 56px;
			}
			::v-deep .el-input--suffix .el-input__inner{
				height: 100%;
				font-size: 18px;
				background-color: #F7F2EB;
				border: none;
				color: #282E30;
			}
			::v-deep .el-time-spinner__item{
				text-align: center;
			}
			.calendar_header{
				margin-top: 30px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #FFFFFF;
				img{
					width: 25px;
					height: 26px;
				}
				.left{
					cursor: pointer;
					span{
						margin-left: 10px;
					}
				}
				.right{
					cursor: pointer;
					span{
						margin-right: 10px;
					}
				}
			}
			.weeklist{
				margin-top: 30px;
				.weekName{
					.item{
						width: 150px;
						height: 60px;
						border: 1px solid #FFFFFF;
						border-radius: 10px;
						padding-left: 30px;
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #FFFFFF;
						line-height: 60px;
						.day{
							margin-left: 15px;
						}
					}
				}
				.course_list{
					margin-top: 20px;
					.day_item{
						width: 150px;
						.item{
							width: 100%;
							height: 200px;
							padding-top: 5px;
							background: #FFFFFF;
							font-size: 16px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #282E30;
							line-height: 30px;
							text-align: center;
							margin-top: 20px;
							border-radius: 10px;
							overflow: hidden;
							&.event_item{
								height: 220px;
								.info{
									height: 80px;
									.name{
										height: 50px;
										line-height: 25px;
										overflow: auto;
										white-space: normal;
									}
								}
							}
							.time{
								text-align: center;
								
							}
							.place{
								text-align: center;
								height: 60px;
							}
							.info{
								height: 60px;
								background: #C98B2C;
								line-height: 26px;
								text-align: center;
								.name{
									text-align: center;
									height: 30px;
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}
								.age{
									font-size: 12px;
									text-align: center;
								}
								&.red{
									background: #BF5F49;
								}
							}
							.tag{
								width: 90px;
								height: 26px;
								border: 1px solid #000000;
								border-radius: 13px;
								font-size: 12px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #000000;
								text-align: center;
								line-height: 26px;
								margin: 7px auto 0;
								cursor: pointer;
							}
						}
					}
				}
				.add_course{
					width: 150px;
					height: 168px;
					background: #FFFFFF;
					border-radius: 10px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					margin-top: 20px;
					cursor: pointer;
					img{
						width: 41px;
						height: 41px;
					}
					.name{
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						margin-top: 15px;
					}
				}
			}
		}
	}
	.course_order{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		margin-top: 20px;
		padding: 30px 36px 30px 24px;
		.header{
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
			}
			.search{
				width: 386px;
				height: 50px;
				background: #F7F2EB;
				border: 1px solid #5C707A;
				border-radius: 25px;
				position: relative;
				img{
					position: absolute;
					width: 33px;
					height: 33px;
					right: 20px;
					top: 50%;
					transform: translateY(-50%);
				}
				input{
					width: 100%;
					height: 100%;
					line-height: 50px;
					padding: 0 70px 0 20px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 200;
					color: #5C707A;
				}
			}
		}
		.tabel_box{
			margin-top: 30px;
			img{
				width: 60px;
				height: 60px;
				border-radius: 10px;
			}
		}
		::v-deep .el-table__header tr{
			background-color: #5C707A;
		}
		::v-deep .el-table th.el-table__cell{
			background-color: #5C707A;
		}
		::v-deep .el-table tr{
			background-color: #F7F2EB;
		}
		::v-deep .el-table__row{
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
		}
		::v-deep .el-table__row .detail{
			color: #5C707A;
			cursor: pointer;
		}
		::v-deep .el-table thead{
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #F7F2EB;
		}
		::v-deep .el-table tbody .el-table__row:hover>td {
		    background-color: transparent !important;
		}
		::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{
			background-color: #F0E3D0;
		}
		::v-deep .el-table th.el-table__cell>.cell{
			word-break: break-work;
		}
		.pages{
			width: 100%;
			display: flex;
			justify-content: flex-end;
			padding-top: 40px;
			::v-deep .btn-prev{
				width: 30px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;	
				padding: 0;
			}
			::v-deep .el-icon{
				font-size: 12px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C1C1C1;
				text-align: center;
			}
			::v-deep .el-pager .number{
				width: 30px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;
				margin-left: 7px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5E5E5E;
				text-align: center;
				line-height: 30px;
				padding: 0;
			}
			::v-deep .el-pager .number.active{
				background: #5C707A;
				color: #FFFFFF;
			}
			::v-deep .btn-next{
				width: 30px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;	
				padding: 0;
				margin-left: 8px;
			}
			::v-deep .el-select{
				width: 90px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;
				margin-left: 15px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5E5E5E;
			}
			::v-deep .el-pagination .el-select .el-input{
				width: 100%;
				height: 100%;
				margin: 0;
			}
			::v-deep .el-pagination .el-select .el-input .el-input__inner{
				padding: 0 6px;
				border: none;
				background-color: #F7F2EB;
				height: 26px;
			}
			::v-deep .el-pagination__editor.el-input{
				width: 40px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5E5E5E;
				text-align: center;
				line-height: 30px;
				padding:0;
				
			}
			::v-deep .el-pagination__editor.el-input .el-input__inner{
				padding:0;
				background-color: #F7F2EB;
				border: none;
				height: 18px;
			}
		}
		
		.bottom_logo{
			margin-top: 70px;
			img{
				width: 55px;
				height: 18px;
				display: block;
				margin: 0 auto;
			}
		}
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		width:140%;
		background-color: rgba(0,0,0,0.3);
		z-index: 9999;
		.model_calendar{
			width: 1240px;
			min-height: 600px;
			// height: 1200px;
			overflow-y: scroll;
			background: #5C707A;
			box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
			border-radius: 10px;
			padding: 30px 20px;
			position: absolute;
			top: 200px;
			left: 50%;
			transform: translateX(-50%);
			.title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				margin-bottom: 20px;
			}
			.calendar_main{
				.select_list{
					.name{
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #F7F2EB;
						margin-right:50px;
						flex-shrink: 0;
					}
					.search{
						width: 208px;
						height: 50px;
						background: #FFFFFF;
						border: 1px solid #5C707A;
						border-radius: 25px;
						position: relative;
						flex-shrink: 0;
						input{
							width: 100%;
							height: 100%;
							font-size: 20px;
							font-family: Source Han Sans CN;
							font-weight: 200;
							color: #5C707A;
							line-height: 50px;
							padding: 0 50px 0 20px;
						}
						img{
							width: 25px;
							height: 25px;
							position: absolute;
							top: 50%;
							right: 10px;
							transform: translateY(-50%);
						}
					}
					.item{
						// padding: 0 10px;
						height: 50px;
						background: #FFFFFF;
						border-radius: 10px;
						margin-left: 20px;
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						img{
							width: 27px;
							height: 15px;
							margin-left: 10px;
						}
					}
				}
				::v-deep .el-select-dropdown__list{
					padding: 15px 0;
				}
				::v-deep .el-select{
					// width: 100%;
					height: 100%;
				}
				::v-deep .el-input.el-input--suffix{
					height: 100%;
				}
				::v-deep .el-input__icon{
					line-height: 56px;
				}
				::v-deep .el-input--suffix .el-input__inner{
					height: 100%;
					font-size: 18px;
					background-color: #F7F2EB;
					border: none;
					color: #282E30;
				}
				::v-deep .el-time-spinner__item{
					text-align: center;
				}
				::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
					width: 150px;
				}
				:v-deep .model .model_content .calendar_main[data-v-13306470] .el-input--suffix .el-input__inner{
					width: 150px;
				}
				.calendar_header{
					margin-top: 30px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #FFFFFF;
					cursor: pointer;
					img{
						width: 25px;
						height: 26px;
					}
					.left{
						span{
							margin-left: 10px;
						}
					}
					.right{
						span{
							margin-right: 10px;
						}
					}
				}
				.weeklist{
					margin-top: 30px;
					.weekName{
						.item{
							width: 150px;
							height: 60px;
							border: 1px solid #FFFFFF;
							border-radius: 10px;
							padding-left: 30px;
							font-size: 24px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #FFFFFF;
							line-height: 60px;
							.day{
								margin-left: 15px;
							}
						}
					}
					.course_list{
						margin-top: 20px;
						.day_item{
							width: 150px;
							.item{
								width: 100%;
								height: 200px;
								padding-top: 5px;
								background: #FFFFFF;
								font-size: 16px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #282E30;
								line-height: 30px;
								text-align: center;
								margin-bottom: 20px;
								border-radius: 10px;
								&.event_item{
									height: 220px;
									.info{
										height: 80px;
										.name{
											height: 50px;
											line-height: 25px;
											overflow: auto;
											white-space: normal;
										}
									}
								}
								.time{
									text-align: center;
									
								}
								.place{
									text-align: center;
									height: 60px;
								}
								.info{
									height: 60px;
									background: #C98B2C;
									line-height: 26px;
									text-align: center;
									.name{
										text-align: center;
										height: 30px;
										overflow: hidden;
										text-overflow: ellipsis;
										white-space: nowrap;
									}
									.age{
										font-size: 12px;
										text-align: center;
									}
									&.red{
										background: #BF5F49;
									}
								}
								.tag{
									width: 90px;
									height: 26px;
									border: 1px solid #000000;
									border-radius: 13px;
									font-size: 12px;
									font-family: Source Han Sans CN;
									font-weight: 400;
									color: #000000;
									text-align: center;
									line-height: 26px;
									margin: 7px auto 0;
									cursor: pointer;
								}
							}
						}
					}
					
				}
			}
			.send{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #CCCCCC;
				margin-top: 100px;
				img{
					width: 16px;
					height: 16px;
					margin-right:10px;
				}
			}
			.submit_btn{
				width: 182px;
				height: 58px;
				background: #F7F2EB;
				border-radius: 29px;
				line-height: 58px;
				text-align: center;
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5C707A;
				margin: 20px auto;
			}
		}
	}
</style>